import { Layout } from "@/components/layout/Layout";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { COUNTRIES } from "@/data/countries";
import { TESTIDS } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

export function Rules() {
  return (
    <Layout>
      <section
        data-testid={TESTIDS.rulesPage}
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10"
      >
        <p className="text-xs uppercase tracking-widest text-muted-foreground">Library</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1">Rules &amp; variations</h1>
        <p className="mt-3 max-w-2xl text-foreground/80">
          Tsoro is not governed by one universal rulebook. The name covers
          several closely related Zimbabwean four-row sowing games, and
          neighbouring countries have their own related mancala traditions.
          Choose a country to read its complete ruleset.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {COUNTRIES.map((c) => (
            <Link
              key={c.slug}
              to={`/rules/${c.slug}`}
              data-testid={TESTIDS.ruleCountry(c.slug)}
            >
              <Card className="p-5 h-full hover:border-primary/60 transition-colors group">
                <div className="flex items-start justify-between">
                  <span className="text-3xl">{c.flag}</span>
                  <Badge variant="outline" className="rounded-full text-[10px] uppercase tracking-widest">
                    {c.region}
                  </Badge>
                </div>
                <p className="font-display text-xl mt-3">{c.name}</p>
                <p className="text-sm text-muted-foreground mt-1 line-clamp-4">{c.blurb}</p>
                <p className="mt-3 text-xs font-medium text-primary inline-flex items-center gap-1">
                  Read rules <ArrowRight className="h-3 w-3" />
                </p>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
